import { Map } from "./map";
import { MapsHomeWork } from "./maps_home_work";
import { MapsUgc } from "./maps_ugc";
import { Mask } from "./masks";
import { MedicalServices } from "./medical_services";
import { MenuBook } from "./menu_book";
import { Message } from "./message";
import { Museum } from "./museum";

const iconsList = [
  { label: "Map", code: <Map /> },
  { label: "MapsHomeWork", code: <MapsHomeWork /> },
  { label: "MapsUgc", code: <MapsUgc /> },
  { label: "Mask", code: <Mask /> },
  { label: "MedicalServices", code: <MedicalServices /> },
  { label: "MenuBook", code: <MenuBook /> },
  { label: "Message", code: <Message /> },
  { label: "Museum", code: <Museum /> },
];

export {
  iconsList,
  Map,
  MapsHomeWork,
  MapsUgc,
  Mask,
  MedicalServices,
  MenuBook,
  Message,
  Museum,
};
